<template>
    <div class="tw:space-y-6">
        <!-- Nombre y Precio -->
        <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
            <BaseInputText
                label="Nombre"
                name="nombre"
                rules="required"
                :value="formData.name"
                @input="formData.name = $event"
            />
            <div>
                <BaseInputNumber
                    label="Precio"
                    :value="formData.precio"
                    :step="0.01"
                    rules="required|decimal"
                    @input="formData.precio = $event"
                />
                <ImporteConGd
                    :gd-taquilla="gd_taquilla"
                    :gd-online="gd_online"
                    :importe="formData.precio || 0"
                />
            </div>
        </div>

        <!-- Indumentarias -->
        <BaseMultiselect
            label="Indumentarias"
            :value="formData.indumentarias_ids"
            :options="indumentarias"
            label-key="nombre"
            value-key="id"
            :multiple="true"
            :loading="loadingIndumentarias"
            @input="formData.indumentarias_ids = $event"
        />

        <!-- Observación indumentarias -->
        <BaseInputText
            v-if="formData.indumentarias_ids.length > 0"
            label="Observación indumentarias"
            name="observacion_indumentarias"
            :value="formData.observacion_indumentarias"
            @input="formData.observacion_indumentarias = $event"
        />

        <!-- Pago a plazos -->
        <PrecioPlazosForm
            :modelValue="precioPlazosData"
            :frecuencias="frecuencias"
            :frecuencias-loading="frecuenciasLoading"
            @update:modelValue="precioPlazosData = $event"
        />

        <!-- Representante -->
        <BaseMultiselect
            label="Representante"
            :value="formData.representante_id"
            :options="representantes"
            label-key="name"
            value-key="id"
            :multiple="false"
            :loading="loadingRepresentantes"
            @input="formData.representante_id = $event || null"
        />

        <!-- Toggles -->
        <div class="tw:flex tw:gap-6 tw:flex-wrap">
            <ToggleSwitch
                :value="formData.taquilla"
                @input="formData.taquilla = $event"
            >
                Activar precio en taquilla
            </ToggleSwitch>
            <ToggleSwitch
                :value="formData.online"
                @input="formData.online = $event"
            >
                Activar precio en online
            </ToggleSwitch>
        </div>

        <!-- Submit -->
        <div class="tw:flex tw:justify-end tw:pt-4">
            <Button
                type="submit"
                :loading="loading"
                :disabled="!isFormValid || loading"
                @click="onSubmit"
            >
                {{ submitLabel }}
            </Button>
        </div>
    </div>
</template>

<script setup>
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue'
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import ImporteConGd from '@/modules/admin/ui/ImporteConGd.vue'
    import PrecioPlazosForm from './PrecioPlazosForm.vue'
    import { useCategoriaForm } from '@/composables/admin/bases/useCategoriaForm'

    const props = defineProps({
        initialData: { type: Object, default: null },
        submitLabel: { type: String, default: 'Guardar' },
        loading: { type: Boolean, default: false }
    })

    const emit = defineEmits(['submit'])

    const {
        formData, isFormValid,
        indumentarias, representantes,
        frecuencias, frecuenciasLoading,
        loadingIndumentarias, loadingRepresentantes,
        gd_online, gd_taquilla,
        precioPlazosData,
        handleSubmit
    } = useCategoriaForm(() => props.initialData)

    function onSubmit() {
        handleSubmit(emit)
    }
</script>
